/* global flowplayer:writable */
import * as native from './native-interface'

var OVERRIDEN_PROPERTIES = 
  [ "currentTime"
  , "muted"
  , "volume"
  , "playbackRate"
  , "in_fullscreen"
  ]

var current_time_timer = null
var current_time_update_timeout = 300

export function create_video_element() {
  var dummy = document.createElement("div")

  var VIDEO = document.createElement("video")
  for (var key in VIDEO) {
    var val = VIDEO[key]
    if (dummy[key]) continue
    try {
      if (typeof val === "function") dummy[key] = function ()  { }
      else if (OVERRIDEN_PROPERTIES.includes(key)) {
        wrap_property_setter(dummy, key, val)
      }
      else dummy[key] = val
    } catch (e) { }
  }
  dummy.canplay = VIDEO.canplay
  wrap_property_setter(dummy, "in_fullscreen", false)
  return wrap_with_methods(dummy)
}

function wrap_property_setter (el, prop, def) {
  el.proxy_values = {}
  OVERRIDEN_PROPERTIES.forEach(function(prop) { el.proxy_values[prop] = def })
  Object.defineProperty(el, prop, {
    get: function() { return el.proxy_values[prop] },
    set: function(value) {
      switch (prop) {
        case "currentTime": {
          if (current_time_timer) clearTimeout(current_time_timer)
          current_time_timer = setTimeout(function () {
            if (!el.root.hasClass("is-seeking")) {
              native.set_current_time(value)
              el.root.toggleClass("is-paused", el.paused)
              el.root.toggleClass("is-playing", !el.paused)
            } else {
              el.root.toggleClass("is-paused", true)
              el.root.toggleClass("is-playing", false)
              el.currentTime = value
            }
          }, current_time_update_timeout)
          break
        } 
        case "muted": {
          if (el.proxy_values["muted"] !== value) native.set_muted(value);
          break
        } 
        case "volume": native.set_volume(value); break
        case "playbackRate": native.set_playback_rate(value); break
        case "in_fullscreen": native.set_fullscreen(value); break
      }
      el.proxy_values[prop] = value
    },
    enumerable: true,
    configurable: true
  })
}

function wrap_with_methods(el) {
  var mq = flowplayer.mq
  el = mq(el)

  el.on(flowplayer.events.SOURCE, function(ev) {
    el.currentSrc = ev.data.src
  })

  el.on(flowplayer.events.LOAD_START, function() {
    el.emit(flowplayer.events.DURATION_CHANGE)
  })
  
  el.load = function () {
    // not supported
  }

  el.play = function() {
    native.play()
  }

  el.pause = function() {
    native.pause()
  }

  el.on(flowplayer.events.MOUNT, function () {
    post_setup(el)
    native.notify_ready()
  })

  el.on(flowplayer.events.SET_QUALITY, function (ev) {
    var level = ev.data.level
    if (!isNaN(level)) native.set_quality(level)
  })

  el.on("audio:set", function (ev) {
    var id = ev.data.id
    if (typeof id !== "undefined") native.set_audio(id)
  })

  el.on("tracks:text:updated", function (ev) {
    if (!ev.data) return
    var id = typeof ev.data.id === "undefined" ? ev.data : ev.data.id
    if (typeof id !== "undefined") native.set_subtitle(id)
  })

  return el
}

function switch_fullscreen_toggle (el) {
  var toggle_fullscreen = function(flag, proxy_only) {
    // invert current state if no explicit state
    if (typeof flag !== "boolean") flag = !el.proxy_values["in_fullscreen"]
    // no change
    if (flag === el.proxy_values["in_fullscreen"]) return
    proxy_only ? el.proxy_values["in_fullscreen"] = flag : el.in_fullscreen = flag
  }

  replace_event_handler(get_element_by_class(el.root, 'fp-fullscreen'), 'click', el.toggleFullScreen, toggle_fullscreen)
  replace_event_handler(get_element_by_class(el.root, 'fp-fullscreen-exit'), 'click', el.toggleFullScreen, toggle_fullscreen)
  
  el.toggleFullScreen = toggle_fullscreen
}

function switch_mute_toggle (video) {
  // Do not change volume when muting. To be handled in SDK.
  var toggle_mute = function (flag) {
    if (typeof flag != "boolean") flag = !video.muted
    video.muted = !video.muted
  }
  replace_event_handler(get_element_by_class(video.root, 'fp-volumebtn'), 'click', video.toggleMute, toggle_mute)
  video.toggleMute = toggle_mute
} 

function post_setup(el) {
  var video = flowplayer.mq(el)
  switch_fullscreen_toggle(video)
  switch_mute_toggle(video)
}

function get_element_by_class(el, name) {
  if (!el) return
  var elems = el.getElementsByClassName(name)
  if (elems && elems.length > 0) return elems[0]
}

function replace_event_handler (el, name, from, to) {
  if (!el) return
  el.off(name, from)
  el.on(name, to)
}
